import React, { createContext, useContext, useState, useEffect } from 'react';

const OrganizerAuthContext = createContext();

export const OrganizerAuthProvider = ({ children }) => {
  const [organizer, setOrganizer] = useState(() => {
    try {
      const stored = localStorage.getItem('organizer_data');
      const expires = localStorage.getItem('organizer_expires');
      if (stored && expires && new Date(expires) > new Date()) {
        return JSON.parse(stored);
      }
      localStorage.removeItem('organizer_data');
      localStorage.removeItem('organizer_expires');
      return null;
    } catch { return null; }
  });
  const [loading, setLoading] = useState(false);

  const login = async (email, password, subEventId) => {
    setLoading(true);
    try {
      const res = await fetch('/api/organizer/login', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email, password, sub_event_id: subEventId }),
      });
      const data = await res.json();
      if (!data.success) throw new Error(data.error || 'Login failed');

      const expires = new Date(Date.now() + 8 * 60 * 60 * 1000).toISOString(); // 8h
      localStorage.setItem('organizer_data', JSON.stringify(data.organizer));
      localStorage.setItem('organizer_expires', expires);
      if (data.organizer.token) {
        localStorage.setItem('organizer_token', data.organizer.token);
      }
      setOrganizer(data.organizer);
      return { success: true };
    } catch (err) {
      return { success: false, error: err.message };
    } finally {
      setLoading(false);
    }
  };

  const logout = () => {
    localStorage.removeItem('organizer_data');
    localStorage.removeItem('organizer_expires');
    localStorage.removeItem('organizer_token');
    setOrganizer(null);
  };

  // Headers à passer pour les endpoints protégés (ex: registration-codes)
  const orgHeaders = () => {
    const token = localStorage.getItem('organizer_token') || organizer?.token || '';
    const id    = organizer?.id || '';
    return { 'X-Org-Token': token, 'X-Org-Id': id };
  };

  const canAccessSubEvent = (subEventId) => {
    if (!organizer) return false;
    if (organizer.role === 'admin') return true;
    return (organizer.sub_event_ids || []).includes(subEventId);
  };

  return (
    <OrganizerAuthContext.Provider value={{ organizer, loading, login, logout, canAccessSubEvent, orgHeaders }}>
      {children}
    </OrganizerAuthContext.Provider>
  );
};

export const useOrganizerAuth = () => useContext(OrganizerAuthContext);
